import { render, staticRenderFns } from "./p_esg024.vue?vue&type=template&id=66dbd0f0&scoped=true&"
import script from "./p_esg024.vue?vue&type=script&lang=js&"
export * from "./p_esg024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dbd0f0",
  null
  
)

export default component.exports